import {
  ITranscriptChunk,
  TranscriptStatus,
} from '../models/transcription.models';

export const transcriptChunkMock: ITranscriptChunk = {
  transcriptChunkId: '1',
  transcriptId: '1',
  audioChunkFileKey: '1',
  text: 'text',
  speaker: 'speaker',
  timestampStart: 1,
  timestampStartTimestamp: '1',
  timestampEnd: 2,
  timestampEndTimestamp: '2',
  status: TranscriptStatus.Completed,
  savedQuote: false,
};
